import { logError } from "@entrilia/shared/logging";
import biApi from "../../../../../../api/biApi";
import { createTypedAsyncThunk } from "../utils/createTypedAsyncThunk";
import { createReportTemplatesAction } from "../utils/storeUtils";

export const loadCompanyReportTemplates = createTypedAsyncThunk(
  "store/loadCompanyReportTemplates",
  async (_, { dispatch }) => {
    try {
      const response = await biApi.getCompanyReportTemplates();
      if (response.success && response.data !== undefined) {
        dispatch(createReportTemplatesAction("setTemplates", response.data));
        return response.data;
      }
      throw new Error("Failed to load company report templates");
    } catch (error) {
      logError(error, "[loadCompanyReportTemplates]");
      throw error;
    }
  }
);
